import { render, staticRenderFns } from "./explosiveproducts.vue?vue&type=template&id=71b98cc8&scoped=true&"
import script from "./explosiveproducts.vue?vue&type=script&lang=js&"
export * from "./explosiveproducts.vue?vue&type=script&lang=js&"
import style0 from "./explosiveproducts.vue?vue&type=style&index=0&id=71b98cc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b98cc8",
  null
  
)

export default component.exports